'use strict'

function IsCssSupported(rule) {
  if (rule in document.documentElement.style === true) {
    return true
  }

  return false
}

export default IsCssSupported
